import { type PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { IS_PRODUCTION } from '@/shared/consts/env';
import { THIS_IS_DEFAULT_STATIC_OR_SERVER_SIDE_PROPS } from '@/utils/next';
import { type MetaProps } from './Meta';
const WHITE_LIST: RegExp[] = [/^\/admin/];
export const RequireDefaultPageProps = (props: PropsWithChildren<Pick<MetaProps, 'pageProps'>>) => {
  const {
    pathname
  } = useRouter();
  const noDefaultStaticOrServerSideProps = props.pageProps[THIS_IS_DEFAULT_STATIC_OR_SERVER_SIDE_PROPS] !== true;
  const isNotWhiteList = !WHITE_LIST.some(regex => regex.test(pathname));
  if (IS_PRODUCTION) {
    return props.children;
  }
  if (noDefaultStaticOrServerSideProps && isNotWhiteList) {
    throw new Error('페이지 컴포넌트에 GetDefaultStaticProps 또는 GetDefaultServerSideProps를 사용하세요!');
  }
  return props.children;
};